import {I18n} from '@aws-amplify/core';
import {
    PlatformPropertyCard,
    PlatformPropertyCardCopyButtonDecorator,
    PlatformPropertyCardEntryInput
} from "@flexinet/ui-components";
import {ProductLineItem} from "../types.ts";
import {CreatedByProfileFormatter, UserProfile} from "../../../components/CreatedByProfileFormatter.tsx";


// ⚠️ Typed PlatformPropertyCardEntryInput[], never cast (§13). Cast, the timestamps carried
// `formatAs: 'Timestamp'`, a key the card does not read, so Created and Last Updated
// rendered as raw ISO strings and tsc could not see it (the products module had the same
// defect, FNP-1898).
export const Profile = ({record}: { record: ProductLineItem }) => {

    const properties: PlatformPropertyCardEntryInput[] = [
        {
            label: I18n.get('Product Name'),
            value: record.product?.name ?? record.productId,
            decorator: (value: string) => <PlatformPropertyCardCopyButtonDecorator value={value}/>,
            span: 12,
        }, {
            label: I18n.get('Product Feature Name'),
            value: record.productFeature?.name ?? record.productFeatureId,
            span: 12,
        }, {
            label: I18n.get('Position'),
            value: typeof record.position === 'number' ? String(record.position) : undefined,
            emptyAs: 'dash',
            span: 12,
        },
        // A read field, shown to whoever can read the record. It was gated on
        // UpdateProductLineItem, a write action. The formatter requires a username, so the
        // row is omitted when the record has none.
        ...(record.createdByUsername ? [{
            label: I18n.get('Created By'),
            value: <CreatedByProfileFormatter record={record as unknown as UserProfile}/>,
            span: 12,
        }] : []),
        {
            label: I18n.get('Created'),
            value: record.created,
            formatter: 'timestamp',
            emptyAs: 'dash',
            span: 12,
        },
        {
            label: I18n.get('Last Updated'),
            value: record.updated,
            formatter: 'timestamp',
            emptyAs: 'dash',
            span: 12,
        }];


    return (
        <PlatformPropertyCard properties={properties}/>
    );


};
